import { render } from "./FeaturesBlock.vue?vue&type=template&id=62cee450"
import script from "./FeaturesBlock.vue?vue&type=script&lang=js"
export * from "./FeaturesBlock.vue?vue&type=script&lang=js"

import "./FeaturesBlock.vue?vue&type=style&index=0&id=62cee450&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__